(function(){
  'use strict';
  var states=new Map();
  function load(kind){
    if(states.has(kind))return states.get(kind);
    var templates=Array.from(document.querySelectorAll('template[data-sh-home-resource="'+kind+'"]'));
    var request=templates.reduce(function(chain,template){
      return chain.then(function(){
      if(template.dataset.loaded)return Promise.resolve();
      return new Promise(function(resolve,reject){
        var node=template.content.firstElementChild.cloneNode(true);
        node.onload=function(){template.dataset.loaded='true';resolve();};
        node.onerror=function(){node.remove();reject(new Error('Could not load '+kind));};
        template.parentNode.insertBefore(node,template);
      });
      });
    },Promise.resolve());
    states.set(kind,request);
    request.catch(function(){states.delete(kind);});
    return request;
  }
  var grid='[data-sh-universal-grid]';
  var cardAction='[data-sh-uc-media-choice], [data-sh-uc-quick], [data-sh-uc-open-palette], [data-sh-uc-choice]';
  function kinds(target){
    var result=[];
    if(target.closest(cardAction))result.push('cards');
    return result;
  }
  function ready(kind){return Array.from(document.querySelectorAll('template[data-sh-home-resource="'+kind+'"]')).every(function(t){return t.dataset.loaded;});}
  ['pointerover','pointerdown','focusin'].forEach(function(type){
    window.addEventListener(type,function(event){
      if(!event.target.closest)return;
      var requests=kinds(event.target);
      if(event.target.closest(grid)&&requests.indexOf('cards')<0)requests.push('cards');
      requests.forEach(function(kind){load(kind).catch(function(){});});
    },{capture:true,passive:true});
  });
  var waiting=new WeakSet();
  window.addEventListener('click',function(event){
    if(!event.target.closest||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button>0)return;
    var needs=kinds(event.target).filter(function(kind){return !ready(kind);});
    if(!needs.length)return;
    var control=event.target.closest(cardAction);
    event.preventDefault();event.stopImmediatePropagation();
    if(waiting.has(control))return;
    waiting.add(control);
    var previousBusy=control.getAttribute('aria-busy');
    control.setAttribute('aria-busy','true');
    Promise.all(needs.map(load)).then(function(){
      if(control.isConnected)control.click();
    }).catch(function(){
      var link=control.closest('a[href]');
      if(link)window.location.assign(link.href);
    }).finally(function(){
      waiting.delete(control);
      if(previousBusy===null)control.removeAttribute('aria-busy');else control.setAttribute('aria-busy',previousBusy);
    });
  },true);
  function start(){
    var roots=document.querySelectorAll(grid);
    if(!('IntersectionObserver' in window)){if(roots.length)load('cards').catch(function(){});return;}
    var observer=new IntersectionObserver(function(entries){
      if(entries.some(function(entry){return entry.isIntersecting;})){
        load('cards').then(function(){observer.disconnect();}).catch(function(){});
      }
    },{rootMargin:'600px 0px'});
    roots.forEach(function(root){observer.observe(root);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

